const MODULE_NAME = 'OfflineModule';

// eslint-disable-next-line import/prefer-default-export
export const GET_IS_OFFLINE_STATUS = `${MODULE_NAME}/GET_IS_OFFLINE_STATUS`;
